import '@/controllers'
import '@/initializers'
import '@hotwired/turbo-rails'
import 'bootstrap'
import 'easymde/dist/easymde.min.css'
import '~assets/stylesheets/application.scss'

// Vite automatically handles static assets
sessionStorage.removeItem('tableTasksWithChildren') // ensure empty value after page refresh
